import React from "react";
import { BadgeProps, BadgeBlack } from "./Badge";

export const DepositPaidBadge = (props: BadgeProps): React.ReactElement => (
  <BadgeBlack {...props} icon={"DEPOSIT_PAYMENT"}>
    Deposit paid
  </BadgeBlack>
);
